import React, { cloneElement, Fragment } from "react";
import { useDispatch } from "react-redux";
import { setAnsweringQuestionsAction } from "../../../../redux/answeringQuestions/answeringQuestions";

const AnswerListController = ( props ) => {

  const dispatch = useDispatch();
  const setAnsweringQuestions = payload => { dispatch( setAnsweringQuestionsAction( payload ) ) };

  const change = ( event ) => {
    setAnsweringQuestions( { answerIndex : event.target.value } );
  };

  return cloneElement( props.children || <Fragment />, {
    onChange : change
  } );

};

export default AnswerListController;
